import { Component, Input } from '@angular/core';

import { BaseFormList, MessageService } from '../../../../core';

import { RepresentanteAtendente } from './representante-atendente';
import { Usuario } from '../../../usuario';

@Component({
    selector: 'sgt-representante-atendente',
    templateUrl: './representante-atendente.component.html',
    styleUrls: ['./representante-atendente.component.less']
})
export class RepresentanteAtendenteComponent implements BaseFormList<RepresentanteAtendente> {
    @Input() entities: RepresentanteAtendente[];

    constructor(private messageService: MessageService) { }


    /** Ao alterar o usuário Atendente */
    onChangeUsuario(entity: RepresentanteAtendente, usuarioAtendente: Usuario) {
        if (usuarioAtendente) {
            entity.idUsuarioAtendente = usuarioAtendente.id;
        } else {
            entity.idUsuarioAtendente = null;
        }
    }


    insert() {
        const entity = new RepresentanteAtendente();
        this.entities.push(entity);
    }

    delete(index: number) {
        const entity = this.entities[index];
        this.messageService.confirm(`Deseja realmente excluir o atendente ${(entity && entity.usuarioAtendente) ? entity.usuarioAtendente.nome : ''} do representante?`).then(result => {
            if (result) {
                this.entities.splice(index, 1);
            }
        });
    }

    /** Verifica se os atendentes do representante estão válidos */
    isValid(): boolean {
        for (let i = 0; i < this.entities.length; i++) {
            const entity = this.entities[i];


            const count = this.entities.filter(entityFilter => entityFilter.idUsuarioAtendente && entityFilter.idUsuarioAtendente === entity.idUsuarioAtendente).length;
            const nome = (entity && entity.usuarioAtendente) ? entity.usuarioAtendente.nome : ''
            if (count > 1) {
                this.messageService.info(`O Atendente ${nome} já está adicionado. Remova ou altere o atendente duplicado`, 'Não é possível adicionar o mesmo atendente mais de uma vez');
                return false;
            }
        }

        return true;
    }

    /** Resolve os atendentes do representante */
    resolve() {
        for (let i = this.entities.length; i--; ) {
            const entity = this.entities[i];
            if (!entity.idUsuarioAtendente) {
                this.entities.splice(i, 1);
            }
        }
    }
}
